import nomirioLogo from "@/assets/nomirio-logo.png";

interface NomirioLogoProps {
  size?: "sm" | "md" | "lg" | "header";
  className?: string;
  priority?: boolean;
}

const sizes = {
  sm: "h-7 max-w-[8rem]",
  md: "h-8 max-w-[9.5rem] md:h-10 md:max-w-[12rem]",
  lg: "h-10 max-w-[12rem] md:h-12 md:max-w-[14rem]",
  header: "h-8 max-w-[9.25rem] md:h-10 md:max-w-[12rem]",
};

const NomirioLogo = ({ size = "md", className = "", priority = false }: NomirioLogoProps) => (
  <img
    src={nomirioLogo}
    alt="Nomirio - The World's 1st Domain Request Hub"
    loading={priority ? "eager" : "lazy"}
    fetchPriority={priority ? "high" : "auto"}
    decoding="async"
    className={`${sizes[size]} nomirio-logo block w-auto object-contain object-left ${className}`}
  />
);

export default NomirioLogo;
